import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Breadcrumbs, Button, DetailDrawer, Tabs } from "InnoUI/components";
import SC from "./style";
import { useSelector } from "react-redux";
import { AddAdditionalContact, ImagePreview } from "components";
import theme from "theme";
import { useSearchParams } from "react-router-dom";
import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import { useDispatch } from "react-redux";
import { fetchSIngleProjectAction } from "@store/project/actions";
import InnoIcons from "@InnoIcons/";
import AddEditProjects from "views/AdminSettings/Projects/AddEditProjects";
import LinkProjects from "views/AdminSettings/Projects/LinkProjects";
import AddLevel from "views/AdminSettings/Projects/AddLevel";
import OccupantTab from "views/AdminSettings/Projects/Occupant/OccupantTab";
import AssignUser from "views/AdminSettings/Projects/AssignUser";
import { getNestedAccess, isEmpty } from "utils/helper";
import GeneralInformation from "../ProjectGeneralInformartion/GeneralInformation";
import Reports from "../ProjectGeneralInformartion/Reports";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import { userAccessType } from "utils/lookUpTable";

const ProjectInformation = (props) => {
  const { defaultTab = 0 } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const [selectedSubLevel, setSelectedSubLevel] = useState({});
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const projectParamId = searchParams.get("projectId");
  const navigate = useNavigate();
  const [levelImage, setLevelImage] = useState();
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [openButton, setOpenButton] = useState(null);
  const [openDrwer, setOpenDrwer] = useState(false);
  const [openModalView, setOpenModalView] = useState(false);
  const [openAddlevelDrawer, setOpenAddlevelDrawer] = useState(false);
  const [openAddOccupant, setOpenAddOccupant] = useState(false);
  const [openAssignUserDrawer, setopenAssignUserDrawer] = useState(false);
  const [projectLevelCount, setProjectLevelCount] = useState([]);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );
  const accessControlData = useSelector(
    (state) => state?.accessControlData?.data || []
  );

  const handleTabChange = (event, newValue) => {
    if (newValue == 0 || newValue == 2) {
      setLevelImage(null);
    }
    setSelectedTab(newValue);
    setSelectedSubLevel({});
  };

  const tabData = [
    { value: 0, label: "General Information" },
    { value: 1, label: "Reports" },
  ];

  useEffect(() => {
    const projectId = !isEmpty(projectParamId)
      ? projectParamId
      : currentProject?.id;
    if (projectId) {
      dispatch(fetchSIngleProjectAction(projectId));
    }
  }, [currentProject?.id, dispatch, projectParamId]);

  const breadcrumbItems = useMemo(() => {
    const baseItems = [
      {
        label: `${currentProject.propertyName || ""}`,
        href: `/project-home`,
      },
    ];

    // Add the dynamic breadcrumb for sub-levels

    if (selectedTab === 1) {
      return [
        ...baseItems,
        { label: "Report" },
        { label: selectedSubLevel?.label },
      ];
    }
    switch (selectedTab) {
      // case 2:
      //   return [...baseItems, { label: "Archived Occupants" }];
      case 2:
        return [...baseItems, { label: "Reports" }];
      default:
        return [...baseItems, { label: "General Information" }];
    }
  }, [currentProject, selectedTab, selectedSubLevel]);

  const closeAssignUserDrawer = () => {
    setopenAssignUserDrawer(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const closeOccupantDrawer = () => {
    setOpenAddOccupant(false);
    setOpenButton(null);
  };

  const handleOccupant = (record) => {
    setOpenAddOccupant(true);
  };

  const closeAddLevelDrawer = () => {
    setOpenAddlevelDrawer(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const editAddLevelDrawer = () => {
    setOpenAddlevelDrawer(true);
    setIsEditing(true);
    setOpenButton(null);
  };

  const handleOpenAddLevelDrawer = () => {
    setOpenAddlevelDrawer(true);
  };

  const handleAddUser = () => {
    // setOpenModalView(true);
    // setopenAssignUserDrawer(true);
    navigate(`/address-book?projectId=${currentProject.id}&type=0`);
  };

  const handleCloseModal = () => {
    setOpenModalView(false);
    setOpenButton(null);
  };

  const closeLinkProjectDrawer = () => {
    setOpenDrwer(false);
    // setRowData(null);
    setOpenButton(null);
  };

  const handleLinkProjects = (record) => {
    setOpenDrwer(true);
    // setRowData(record);
  };

  const closeDrawer = () => {
    setOpen(false);
    setIsEditing(false);
    setOpenButton(null);
  };

  const handleEditProject = () => {
    setOpen(true);
    setIsEditing(true);
  };

  const actionButtons = [
    {
      key: "edit",
      caption: "Edit Details",
      icon: (isActive) => (
        <InnoIcons.EditIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleEditProject,
      accessKey: "canEditProject",
    },
    {
      key: "linkHoliday",
      caption: "Link Holiday",
      icon: (isActive) => (
        <InnoIcons.LinkOutlined
          style={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleLinkProjects,
      accessKey: "canLinkHolidayToProject",
    },
    {
      key: "addUser",
      caption: "Manage Users",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleAddUser,
      accessKey: "canAddUserToProject",
    },
  ];

  const actionButtonLevel = [
    {
      key: "newLevel",
      caption: "New Level",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleOpenAddLevelDrawer,
      accessKey: "canAddLevel",
    },
    {
      key: "editLevel",
      caption: "Edit Level",
      icon: (isActive) => (
        <InnoIcons.EditIcon
          style={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: editAddLevelDrawer,
      accessKey: "canEditLevel",
      disabled: () => projectLevelCount.length == 0,
    },
    {
      key: "newOccupant",
      caption: "New Occupant",
      icon: (isActive) => (
        <InnoIcons.AddIcon
          sx={{
            fontSize: "12px",
            color: isActive ? "white" : theme.colors.themeColor,
          }}
        />
      ),
      onClick: handleOccupant,
      accessKey: "canAddOccupant",
      disabled: () => projectLevelCount.length == 0,
    },
  ];

  function transformData(input) {
    return {
      id: input?.value,
      name: input?.label,
      image: input?.image,
    };
  }
  const transformedData = transformData(selectedSubLevel);

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
      />
      <SC.BodyContainer>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </SC.BodyContainer>

      <CheckPermissionWrapper>
        {({ permission }) => (
          <>
            {(permission == userAccessType.write ||
              permission == userAccessType.read) && (
              <>
                <SC.Container>
                  <SC.ActiveContainer>
                    <div style={{ display: "flex" }}>
                      <SC.ImageContainer>
                        <SC.Image>
                          <ImagePreview
                            src={currentProject.logoImage}
                            height="100%"
                            width="100%"
                            style={{ objectFit: "contain" }}
                          />
                        </SC.Image>
                      </SC.ImageContainer>
                      <SC.ProjectDiv>
                        <SC.PropertyName>
                          {currentProject.propertyName}
                        </SC.PropertyName>
                        <SC.Status currentProject={currentProject}>
                          {currentProject.status === 1 ? "Active" : "Inactive"}
                        </SC.Status>
                        <SC.Email>{currentProject.email}</SC.Email>
                      </SC.ProjectDiv>
                    </div>
                  </SC.ActiveContainer>
                  <div style={{ marginLeft: "15px" }}>
                    <Tabs
                      value={selectedTab}
                      label={tabData.map((tab) => tab.label)}
                      onChange={handleTabChange}
                      selectedValue={selectedTab}
                    />
                  </div>
                  {selectedTab === 0 && (
                    <SC.ButtonContaiiner>
                      {actionButtons
                        .filter((btn) =>
                          getNestedAccess(accessControlData, btn.accessKey)
                        )
                        .map((btn) => {
                          const isActive = openButton === btn.key;
                          return (
                            <Button
                              key={btn.key}
                              leftIcon={btn.icon(isActive)}
                              caption={btn.caption}
                              fontSize="11px"
                              color={
                                isActive ? "white" : theme.colors.themeColor
                              }
                              onClick={() => {
                                setOpenButton(btn.key);
                                btn.onClick();
                              }}
                              style={{
                                background: isActive
                                  ? theme.colors.themeColor
                                  : theme.colors.white,
                                minWidth: "100px",
                                borderRadius: "3px",
                                height: "28px",
                                fontSize: "12px",
                                border: `1px solid ${theme.colors.themeColor}`,
                              }}
                            />
                          );
                        })}
                    </SC.ButtonContaiiner>
                  )}

                  {selectedTab === 0 && (
                    <div
                      style={{
                        borderTop: `1px solid ${theme.colors.bordertask}`,
                      }}
                    >
                      <GeneralInformation />
                    </div>
                  )}

                  {selectedTab === 1 && (
                    <div
                      style={{
                        borderTop: `1px solid ${theme.colors.bordertask}`,
                      }}
                    >
                      <Reports
                        setSelectedSubLevel={setSelectedSubLevel}
                        selectedSubLevel={selectedSubLevel}
                      />
                    </div>
                  )}
                </SC.Container>
              </>
            )}
          </>
        )}
      </CheckPermissionWrapper>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <AddEditProjects
              projectdata={currentProject}
              onClose={closeDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              rowId={currentProject.id}
              reload={true}
              // setProjects={setProjects}
              // fetchData={getAllProjects}
            />
          }
        />
      )}

      {openDrwer && (
        <DetailDrawer
          open={openDrwer}
          onClose={closeLinkProjectDrawer}
          title={false}
          width={"650px"}
          children={
            <LinkProjects
              onClose={closeLinkProjectDrawer}
              projectData={currentProject}
              // setSelectedItem={setSelectedItems}
              // fetchData={getAllProjects}
              setOpenDrwer={setOpenDrwer}
            />
          }
        />
      )}

      {openModalView && (
        <AddAdditionalContact
          openModalView={openModalView}
          onClose={handleCloseModal}
          createTO={true}
          // setPropData={setData}
        />
      )}

      {openAddlevelDrawer && (
        <DetailDrawer
          open={openAddlevelDrawer}
          onClose={closeAddLevelDrawer}
          title={false}
          width={"650px"}
          children={
            <AddLevel
              projectdata={transformedData}
              onClose={closeAddLevelDrawer}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              // rowId={selectedSubLevel.value}
              projectId={currentProject.id}
              // setProjects={setProjects}
              reload={false}
              setSelectedTab={setSelectedTab}
            />
          }
        />
      )}

      {openAddOccupant && (
        <DetailDrawer
          open={openAddOccupant}
          onClose={closeOccupantDrawer}
          title={false}
          width={"700px"}
          children={
            <OccupantTab
              // occupantdata={rowData}
              // levelId={rowAllData.id}
              Projectdata={currentProject}
              onClose={closeOccupantDrawer}
              // fetchData={getAllOccupant}
              // rowId={rowId}
              isInfo={false}
              // setOccupant={setOccupant}
              isLevel={true}
              setSelectedTabb={setSelectedTab}
            />
          }
        />
      )}

      {openAssignUserDrawer && (
        <DetailDrawer
          open={openAssignUserDrawer}
          onClose={closeAssignUserDrawer}
          width={"70%"}
          children={
            <AssignUser
              // userdata={fieldData}
              onClose={closeAssignUserDrawer}
              project={currentProject}
              // fetchData={getAlldata}
              hideColumns={["cell", "userType", "createdAt", "roleNames"]}
              isDisabled={true}
            />
          }
        />
      )}
    </>
  );
};

export default ProjectInformation;
